(function () {
  if (window.dailyPetBuyNowReady) return;
  window.dailyPetBuyNowReady = true;

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled) return;

    var productForm = button.closest('product-form');
    var form = productForm && productForm.querySelector('form');
    if (!form || !form.reportValidity()) return;

    var errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
    var errorMessage = productForm.querySelector('.product-form__error-message');
    var originalText = button.textContent.trim();

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Redirecting...';
    if (errorWrapper) errorWrapper.hidden = true;

    try {
      var localeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var cartAddUrl = window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url + '.js'
        : localeRoot + 'cart/add.js';
      var response = await fetch(cartAddUrl, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      var result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || 'Unable to continue to checkout.');
      }

      window.location.assign(localeRoot + 'checkout');
    } catch (error) {
      if (errorMessage) errorMessage.textContent = error.message;
      if (errorWrapper) errorWrapper.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    }
  });
})();
